export enum AbandonReason {
  Idle = 1,
  MaxTime = 2,
  Unload = 3
}
